import React from 'react';
import './style.scss';
import Markdown from 'react-markdown';
import SectionHeading, { mapSectionHeading } from './SectionHeading';

function Section({ sectionData, sectionName, title, text, line, children, subSection }) {
  const section = sectionData ? mapSectionHeading(sectionData) : { sectionName, title, text };
  const childSection = subSection ? mapSectionHeading(subSection) : null;
  return (
    <section className='container bg-primary tb__container lg:py-16 py-12'>
      {line && <hr className='tb__line lg:mb-8' />}
      <SectionHeading
        section={section}
        sectionData={sectionData}
      />
      {childSection && (
        <div className='tb__content pb-10'>
          <p className='p2 uppercase'>{childSection.sectionName}</p>
          <Markdown>{childSection.title}</Markdown>
          {childSection.text && <p className='whitespace-pre-line p2'>{childSection.text}</p>}
        </div>
      )}
      <div className='flex flex-col lg:gap-20 gap-12'>{children}</div>
    </section>
  );
}

export default Section;
